// extracted by mini-css-extract-plugin
export var cardIcon = "_7h-5";
export var checkboxCard = "_7h-0";
export var checkboxCardSelected = "_7h-4";
export var disabled = "_7h-2";
export var interactive = "_7h-1";
export var outerBorder = "_7h-3";
export var spacerMedium = "_7h-8";
export var spacerSmall = "_7h-7";
export var spacerXsmall = "_7h-6";